module.exports = __webpack_public_path__ + "static/media/restsettings.6888c91b.svg";